module.exports = __webpack_public_path__ + "static/media/keyboard.f8bd03a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/keyboard.jpg
// module id = 179
// module chunks = 0